import React, { Suspense, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Canvas } from "@react-three/fiber";
import { Center, OrbitControls, useGLTF, useProgress } from "@react-three/drei";
import "./ProductsMainSectionDetails.css";
import LeftArrow from "../../Assets/LeftIcon.png";
import product01 from "../../Assets/3dImages/reactor.glb";
import product02 from "../../Assets/3dImages/STSA-000finalestsilo.glb";
import product03 from "../../Assets/3dImages/Assemblycomplite-step-two-wayfinal.glb";
import product04 from "../../Assets/3dImages/Mixer_Tank.glb";
import product05 from "../../Assets/3dImages/KMRKRSKLNM1final.glb";
import product06 from "../../Assets/3dImages/pvfinal2.glb";
import Loader from "./ModelLoader";
import FingerSwipe from "../ProductsLayoutDetails/FingerSwipe";

const ProductList = [
  {
    id: 1,
    title: "Environmental",
    image: product05,
    html: (
      <div className="h-100 d-flex flex-column justify-content-center">
        <p className="modal_title fs-1 mb-center">Environmental Equipment</p>
        <p className="modal_text fs-3 mb-center" >
          Our environmental equipment is designed to improve operational
          efficiency while helping your business comply with environmental
          regulations. We offer a range of products for air and water quality
          management, waste reduction, and emissions control.
        </p>
        <ul className="modal_ul_list">
          <li>
            <b>Venturi Scrubbers</b>
          </li>
          <li>
            <b>Packed Tower Scrubbers</b>
          </li>
          <li>
            <b>Quenchers</b>
          </li>
          <li>
            <b>Separators</b>
          </li>
          <li>
            <b>Moisture Separators</b>
          </li>
        </ul>
      </div>
    ),
    camera: { position: [12, 10, 18], fov: 20 },
  },
  {
    id: 2,
    title: "Silos",
    image: product02,
    camera: { position: [100, 0, -100], fov: 10 },
    html: (
      <div className="h-100 d-flex flex-column justify-content-center">
        <p className="modal_title fs-1">Silos</p>
        <p className="modal_text fs-3 mb-center">
          Our silos are engineered for the storage of powders, granules, and
          liquids, emphasising durability and minimal maintenance. We offer
          solutions with scalable capacities and a range of discharge options.
        </p>
        <ul className="modal_ul_list">
          <li>
            <b>Capacity:</b> 5T to 200T (Customizable)
          </li>
          <li>
            <b>Coatings:</b> Epoxy, Polyurethane, Food-grade
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 3,
    title: "Heat exchangers",
    image: product03,
    camera: { position: [-15, 10, 10], fov: 8 },
    html: (
      <div className="h-100 d-flex flex-column justify-content-center">
        <p className="modal_title fs-1" >
          Heat Exchangers
        </p>
        <p className="modal_text fs-3 mb-center">
          Our heat exchangers provide superior heat transfer efficiency, built for long-term performance and exceptional durability. They offer reliability even in the most demanding environments, making them an ideal choice for industrial applications.
        </p>
        <ul className="modal_ul_list">
          <li>
            <b>Type:</b> Shell & Tube Heat Exchangers with Bellows
          </li>
          <li>
            <b>Pressure Rating:</b> Up to 200 bar (depending on material and
            design)
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 4,
    title: "Reactors",
    image: product01,
    html: (
      <div className="h-100 d-flex flex-column justify-content-center">
        <p className="modal_title fs-1">Reactors</p>
        <p className="modal_text fs-3 mb-center">
          Our reactors are built to handle complex chemical processes, complying with the highest industry standards and tailored to meet your exact process requirements.
        </p>
        <ul className="modal_ul_list">
          <li>
            <b>Types:</b> Limpet Reactors, Jacketed Reactors, Half-pipe Jacket
            Reactors
          </li>
        </ul>
      </div>
    ),
    camera: { position: [-15, 10, 80], fov: 2 },
  },
  {
    id: 5,
    title: "Custom Fabrication",
    image: product04,
    camera: { position: [0, 50, 300], fov: 30 },
    html: (
      <div className="h-100 d-flex flex-column justify-content-center">
        <p className="modal_title fs-1">Custom Fabrication</p>
        <p className="modal_text fs-3 mb-center">
          We specialise in custom-fabricated equipment tailored to individual
          client specifications. We collaborate closely with clients to
          deliver high-quality equipment that meets unique needs and industry
          standards. The focus is on ensuring durability and longevity for the
          fabricated products.
        </p>
      </div>
    ),
  },
  {
    id: 6,
    title: "Tanks & Vessels",
    image: product06,
    camera: { position: [12, 15, 10], fov: 15 },
    html: (
      <>
        <p className="modal_title">Tanks & Vessels</p>
        <p className="modal_text">
          Our tanks and vessels are built to serve a variety of industrial
          applications. Whether for storage, pressure containment, or mixing,
          we provide durable, high-quality equipment built to your exact
          specifications.
        </p>
        <p className="modal_semi_title">Storage Tanks</p>
        <ul className="modal_ul_list">
          <li>
            <b>Capacity:</b> 1 kL to 50 kL{" "}
          </li>
          <li>
            <b>Geometry:</b> Horizontal,Vertical
          </li>
          <li>
            <b>Types:</b> Single-walled, Double-walled{" "}
          </li>
          <li>
            <b>Coating:</b> Epoxy
          </li>
        </ul>
        <p className="modal_semi_title">Industrial Vessels</p>
        <ul className="modal_ul_list">
          <li >
            <b>Pressure Vessels:</b>
            <ul className="modal_ul_list">
              <li>Cylindrical Pressure Vessels</li>
              <li>Custom Pressure Vessels</li>
            </ul>
          </li>
          <li>
            <b>Mixing Vessels:</b>
            <ul className="modal_ul_list">
              <li>Limpeted Vessels</li>
              <li>Internal Coil Vessels</li>
            </ul>
          </li>
          <li>
            <b>Specialty Vessels:</b>
            <ul className="modal_ul_list">
              <li>Hot Water Generators</li>
              <li>Nitrogen Storage Tanks</li>
              <li>Propane Tanks</li>
            </ul>
          </li>
        </ul>
        <p className="modal_semi_title">Process Tanks</p>
        <ul className="modal_ul_list">
          <li>Recovery Tanks</li>
          <li>Blowdown Tanks</li>
          <li>Flash Tanks</li>
          <li>Expansion Tanks</li>
          <li>Surge Tanks</li>
        </ul>
        <p className="modal_semi_title">Receivers</p>
        <ul className="modal_ul_list">
          <li>Air Receivers</li>
          <li>Horizontal Ammonia Receivers</li>
          <li>Vertical Ammonia Receivers</li>
        </ul>
        <p className="modal_semi_title">Columns and Filters</p>
        <ul className="modal_ul_list">
          <li>Distillation Columns</li>
          <li>Filter Vessels</li>
        </ul>
        <p className="modal_semi_title">Custom Solutions</p>
        <ul className="modal_ul_list">
          <li>Jacketing</li>
          <li>Mixers</li>
          <li>Specialised Equipment</li>
        </ul>
        <p className="modal_semi_title">Additional Products</p>
        <ul className="modal_ul_list">
          <li>Accumulators</li>
          <li>LP Heater Assembly</li>
          <li>Propane Dispenser Tanks</li>
        </ul>
      </>
    ),
  },
];

function ModelViewer({ modelPath }) {
  const { scene } = useGLTF(modelPath);

  useMemo(() => {
    scene.traverse((child) => {
      if (child.isMesh) {
        child.material.color.set("#ffffff");
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [scene]);

  return <primitive object={scene} scale={1} />;
}

const ProductsMainSectionDetails = () => {
  const { progress } = useProgress();

  const [showSwipe, setShowSwipe] = useState(false);
  useEffect(() => {
    setShowSwipe(progress === 100)
  }, [progress])

  const { id } = useParams();
  const navigate = useNavigate();
  const selectedProduct = ProductList.find((p) => p.id === +id);
  if (!selectedProduct) return <p>Product Model Not Found</p>;

  return (
    <div className="main-container-productdetails">
      <section id="products" className="container">
        <div
          onClick={() => navigate("/products")}
          style={{
            position: "fixed",
            top: "10%",
            left: 80,
            zIndex: 9999,
            cursor: "pointer",
          }}
        >
          <img src={LeftArrow} width={24} height={24} alt="Back" className="btn_LeftArrow" />
        </div>

        <div className="row pb-4">
          <div className="cover_products">
            <div className="modal-con-productdetails mb-2" style={{ position: 'relative' }}>
              <Canvas
                shadows
                camera={selectedProduct.camera}
              >
                <ambientLight intensity={0.3} />
                <directionalLight position={[100, 0, 0]} />

                <directionalLight position={[-100, 0, 0]} />

                <directionalLight position={[0, 100, 0]} />

                <directionalLight position={[0, 0, 100]} />

                <directionalLight position={[0, 0, -100]} />
                <Suspense fallback={<Loader />}>
                  <Center>
                    <ModelViewer modelPath={selectedProduct.image} />
                  </Center>
                </Suspense>
                <OrbitControls enableZoom onStart={() => setShowSwipe(false)} />
              </Canvas>
              {showSwipe && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    top: 0,
                    pointerEvents: 'none',
                  }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <FingerSwipe />
                </div>
              )}

            </div>
            <div className="text-con--productdetails">
              {selectedProduct.html}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsMainSectionDetails;
